<template>
    <div class="banner-info2 banner-fade-in">
        <div class="banner-info2-content" ref="animate">
            <div class="title">BBG MOVE Travel</div>
            <div class="desc">Our all-inclusive journeys offer unparalleled service and meaningful experiences in China.</div>
        </div>
    </div>
</template>
<script>
export default {
    mounted() {
        this.$nextTick(() => {
            const contentElement = this.$refs.animate;
            contentElement.classList.add('animate');
        })
    }
}
</script>
<style scoped lang="scss">
@import '/style/pc/common/animate.scss';
@import '/style/pc/common/fadeIn.scss';
@import '/style/phone/header/aboutUsBanner.scss';
.banner-info2 {
    background-image: url('/static/img/banner/aboutUs.jpeg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    // max-width: 128rem; 
    width: 100%;
    height: 39.375rem; 
    margin: 0 auto;
    margin-top: 5.5rem; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner-info2-content{
        opacity: 0;
        transform: translateY(100%);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .title{
        color: #fff;
        text-align: center;
        text-shadow: 5px 20px 50px rgba(0, 0, 0, 0.44);
        font-size: 4rem;
        font-weight: 800;
        line-height: 100%; /* 64px */
        font-family: Butler;
        margin-bottom: 2.5rem;
        width: 28.375rem;
    }
    .desc{      
        color: #FFF;
        text-align: center;
        font-family: Inter;
        font-size: 1.25rem;
        font-style: normal;
        font-weight: 300;
        line-height: normal;
        width:48.125rem;
        height: 44px;
    }
}
</style>